<div class="bank-register-section">
  @if (loading()) {
    <div class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Loading bank data...</p>
    </div>
  } @else if (!selectedBank()) {
    <div class="no-bank-selected">
      <p>No bank selected. Please select a bank from the sidebar.</p>
    </div>
  } @else {
    <div class="controls-row">
      <div class="button-group">
        <button mat-raised-button color="primary" (click)="navigateToDeposit()" 
          [disabled]="!bankStore.selected()"
          [matTooltip]="!bankStore.selected() ? 'Select a bank first' : 'Record a deposit'">
          <mat-icon>add</mat-icon>
          Deposit
        </button>
        <button mat-raised-button color="accent" (click)="navigateToWithdrawForm()" 
          [disabled]="!bankStore.selected()"
          [matTooltip]="!bankStore.selected() ? 'Select a bank first' : 'Record a withdrawal'">
          <mat-icon>remove</mat-icon>
          Withdraw
        </button>
      </div>
      <span class="spacer"></span>
    </div>
    
    @if (contactTransactions().length === 0) {
      <div class="no-transactions">
        <p>No transactions found for this bank.</p>
      </div>
    } @else {
      <mat-card class="register-card">
        <mat-card-content>
          <div class="bank-register-container">
            <table class="bank-register-table">
              <thead>
                <tr>
                  <th class="date-col">DATE</th>
                  <th class="category-col">CATEGORY</th>
                  <th class="contact-col">CONTACT</th>
                  <th class="payment-col">DEBIT</th>
                  <th class="deposit-col">CREDIT</th>
                  <th class="balance-col">BALANCE</th>
                  <th class="action-col">ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                @for (transaction of contactTransactions(); track transaction.index) {
                  <tr [ngClass]="{
                    'even-row': transaction.index % 2 === 0, 
                    'has-late-fee': transaction.late_fee !== null && +transaction.late_fee > 0
                  }">
                    <td>
                      {{transaction.original_date_string}}
                    </td>
                    <td>
                      {{formatString(transaction.category)}}
                    </td>
                    <td>{{get_name(transaction.contact_id, transaction.isStartingBalance, transaction)}}</td>
                    <td class="amount-cell">
                      @if (transaction.amount && transaction.amount < 0) {
                        {{-transaction.amount | currency:'USD':'symbol':'1.2-2'}}
                      }
                    </td>
                    <td class="amount-cell"
                        [matTooltip]="getLoanPaymentDetails(transaction)"
                        [matTooltipDisabled]="!isLoanPayment(transaction) || !(transaction.amount && transaction.amount > 0)"
                        matTooltipClass="loan-payment-tooltip"
                        matTooltipPosition="above">
                      @if (transaction.amount && transaction.amount > 0) {
                        {{transaction.amount | currency:'USD':'symbol':'1.2-2'}}
                      }
                    </td>
                    <td class="amount-cell">
                      @if (transaction.balance !== null && transaction.balance !== undefined) {
                        <span [style.color]="transaction.balance < 0 ? '#f44336' : 'inherit'" 
                              [style.font-weight]="transaction.balance < 0 ? 'bold' : 'normal'">
                          {{transaction.balance | currency:'USD':'symbol':'1.2-2'}}
                        </span>
                      } @else {
                        $0.00
                      }
                    </td>
                    <td class="action-cell" style="padding: 0px;text-align:center;">
                      @if(!transaction.isStartingBalance) {
                        <button mat-icon-button
                                color="warn"
                                (click)="deleteTransaction(transaction)"
                                matTooltip="Delete transaction">
                          <mat-icon>clear</mat-icon>
                        </button>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </mat-card-content>
      </mat-card>
    }
  }
</div>
